import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Close } from "../../assets/svgs/icons";

interface ConfirmModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title?: string;
    message: string;
    confirmText?: string;
    onConfirm?: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    open,
    onOpenChange,
    title,
    message,
    confirmText = "확인",
    onConfirm,
}) => {
    const handleConfirm = () => {
        onConfirm?.();
        onOpenChange(false);
    };

    return (
        <Dialog.Root open={open} onOpenChange={onOpenChange}>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 bg-[rgba(33,33,33,0.4)] z-50" />
                <Dialog.Content className="box-border bg-white flex flex-col gap-[40px] items-center justify-center min-w-[300px] w-[328px] overflow-hidden pb-[16px] pt-[40px] px-[16px] rounded-[20px] shadow-[0px_6px_12px_-6px_rgba(0,0,0,0.12),0px_8px_24px_-4px_rgba(0,0,0,0.08)] fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50">
                    {/* X 닫기 버튼 */}
                    <Dialog.Close asChild>
                        <button
                            className="absolute right-0 top-0 p-[12px] w-[48px] h-[48px] flex items-center justify-center"
                            aria-label="닫기"
                        >
                            <Close className="w-[24px] h-[24px]" style={{ fill: "#B2B2B2" }} />
                        </button>
                    </Dialog.Close>

                    {/* 제목 + 메시지 */}
                    <div className="flex flex-col gap-[16px] items-start w-full">
                        {title && (
                            <div className="flex flex-col items-start w-full">
                                <p className="font-bold text-[#212121] text-[16px] leading-[24px] tracking-[-0.32px] text-center w-full">
                                    {title}
                                </p>
                            </div>
                        )}
                        <div className="flex flex-col items-start w-full">
                            <p className="font-medium text-[#212121] text-[14px] leading-[20px] tracking-[-0.28px] text-center w-full whitespace-pre-wrap m-0">
                                {message}
                            </p>
                        </div>
                    </div>

                    {/* 확인 버튼 */}
                    <div className="flex flex-col gap-[16px] items-start w-full">
                        <button
                            className="box-border bg-[#212121] flex items-center justify-center h-[48px] max-h-[48px] min-h-[48px] max-w-[800px] px-[40px] rounded-[24px] w-full"
                            onClick={handleConfirm}
                        >
                            <span className="font-semibold text-[16px] leading-[24px] tracking-[-0.32px] text-white text-center">
                                {confirmText}
                            </span>
                        </button>
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

export default ConfirmModal;
